// extracted by mini-css-extract-plugin
module.exports = {"slide":"blog-post-carousel-slide_slide__FrhmL"};